class UpdateProductVariantLabels {
  // セレクタを引数で受け取れるようにし、変更に強くする
  constructor(pickerSelector = 'variant-picker', badgeSelector = '.product-information .product-badges') {
    this.variantPicker = document.querySelector(pickerSelector);
    this.badgeSelector = badgeSelector;
    this.labelWrapper = document.querySelector(this.badgeSelector);

    // 必須要素が存在する場合のみイベントをバインドする
    if (this.variantPicker && this.labelWrapper) {
      this.init();
    }
  }

  init() {
    this.variantPicker.addEventListener('variant:update', (e) => {
      this.handleVariantUpdate(e);
    });
  }

  handleVariantUpdate(e) {
    try {
      const htmlData = e?.detail?.data?.html;
      if (!htmlData) return;

      let newDoc = htmlData;

      if (typeof htmlData === 'string') {
        const parser = new DOMParser();
        newDoc = parser.parseFromString(htmlData, 'text/html');
      }

      const targetLabelWrapper = newDoc.querySelector(this.badgeSelector);

      if (targetLabelWrapper) {
        this.labelWrapper.innerHTML = targetLabelWrapper.innerHTML;
      }
    } catch (error) {
      console.error('UpdateProductVariantLabels: Failed to update labels.', error);
    }
  }
}

new UpdateProductVariantLabels();